module.exports = __webpack_public_path__ + "img/whatsapp.736146e9.svg";